import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { FaTrash, FaExclamationTriangle } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { budgetApi } from '../../api/budget';
import { handleApiResponse } from '../global/ApiMessageModal/ApiMessageModal';

const FutaBajetiModal = ({ show, onHide, item, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleDelete = async () => {
    if (!item?.id) return;
    setSubmitting(true);
    try {
      const response = await budgetApi.deleteBudget(item.id);
      if (handleApiResponse(response)) {
        toast.success('Kipengele cha bajeti kimefutwa kikamilifu!');
        onHide();
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      console.error('Error deleting budget item:', err);
      handleApiResponse(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold text-danger d-flex align-items-center gap-2">
          <div className="p-2 rounded-3 bg-danger-subtle text-danger d-flex align-items-center justify-content-center">
            <FaExclamationTriangle size={20} />
          </div>
          Thibitisha Kufuta Bajeti
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4 text-center">
        <p className="text-secondary mb-2" style={{ fontSize: '1rem' }}>
          Je, una uhakika unataka kufuta kipengele cha bajeti cha <strong className="text-dark">{item?.category_name}</strong> cha kiasi cha{' '}
          <strong className="text-danger">TZS {(item?.amount || 0).toLocaleString()}</strong>?
        </p>
        <span className="text-muted small">* Kitendo hiki hakina urejesho na data zote za matumizi ya huduma hii zitapotea.</span>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center pb-4">
        <Button variant="light" onClick={onHide} className="rounded-pill px-4 fw-medium border">
          Ghairi
        </Button>
        <Button
          variant="danger"
          onClick={handleDelete}
          disabled={submitting}
          className="rounded-pill px-4 fw-semibold shadow-sm border-0 d-flex align-items-center gap-2"
        >
          {submitting ? <Spinner animation="border" size="sm" /> : <><FaTrash size={14} /> Futa Kipengele</>}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FutaBajetiModal;
